import Feature from "src/js/stores/user/Feature";
import hasFeature from "src/js/stores/user/actions/hasFeature";
import { ComparablesFilterFields } from "../components/Filters/FiltersWithClear";

export const hiddenFieldsByFeature: Array<[() => boolean, Set<ComparablesFilterFields>]> = [
  [() => hasFeature(Feature.usAccess), new Set(["newBuildsOnly", "tenure"])],
  [
    () => !hasFeature(Feature.zooplaFullAccess),
    new Set<ComparablesFilterFields>(["bedrooms", "yearBuiltFrom", "yearBuiltTo"]),
  ],
];
